import React from "react";
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    Font,
    Image,
} from "@react-pdf/renderer";
import Html from "react-pdf-html";
import toRibuan from "../../utils/toRibuan";
import OpenSans from "../../assets/fonts/OpenSans-Regular.ttf";
import OpenSansBold from "../../assets/fonts/OpenSans-Bold.ttf";
import OpenSansSemiBold from "../../assets/fonts/OpenSans-SemiBold.ttf";
import OpenSansMedium from "../../assets/fonts/OpenSans-Medium.ttf";
import UbuntuMono from "../../assets/fonts/UbuntuMono-Regular.ttf";
import toRupiahDesimal from "../../utils/toRupiahDesimal";

Font.register({
    family: "OpenSans",
    format: "truetype",
    src: OpenSans,
});
Font.register({
    family: "OpenSansBold",
    format: "truetype",
    src: OpenSansBold,
});
Font.register({
    family: "OpenSansSemiBold",
    format: "truetype",
    src: OpenSansSemiBold,
});
Font.register({
    family: "OpenSansMedium",
    format: "truetype",
    src: OpenSansMedium,
});
Font.register({
    family: "UbuntuMono",
    format: "truetype",
    src: UbuntuMono,
});

const styles = StyleSheet.create({
    page: {
        backgroundColor: "#FFF",
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 14,
        paddingRight: 14,
        height: "100%",
    },
    containerTitle: {
        display: "flex",
        flexDirection: "column",
        textAlign: "center",
        alignItems: "center",
        justifyContent: "center",
        marginVertical: 12,
    },
    title: {
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 10,
        marginTop: 0,
        marginLeft: "auto",
        marginRight: "auto",
        textAlign: "center",
        fontFamily: "OpenSansSemiBold",
        fontWeight: "bold",
    },
    subtitle: {
        fontSize: 8,
        marginTop: 0,
        marginLeft: "auto",
        marginRight: "auto",
        textAlign: "center",
        fontFamily: "OpenSans",
    },
    cashierName: {
        fontSize: 8,
        marginTop: 6,
        fontFamily: "OpenSans",
    },
    tanggalTransaksi: {
        flexDirection: "row",
        justifyContent: "space-between",
        fontSize: 8,
        fontFamily: "OpenSans",
    },
    containerHeader: {
        flexDirection: "row",
        backgroundColor: "#45A779",
        color: "#fff",
        alignItems: "center",
        height: 24,
        textAlign: "center",
        fontStyle: "bold",
        flexGrow: 1,
    },
    namaHeader: {
        width: "45%",
        fontSize: 14,
        fontWeight: 700,
    },
    hargaHeader: {
        width: "15%",
        fontSize: 14,
        fontWeight: 700,
    },
    jumlahHeader: {
        width: "10%",
        fontSize: 14,
        fontWeight: 700,
    },
    skuHeader: {
        width: "25%",
        fontSize: 14,
        fontWeight: 700,
    },
    row: {
        fontSize: 8,
        flexDirection: "row",
        fontFamily: "OpenSans",
    },
    column: {
        marginTop: 8,
        marginBottom: 4,
        fontSize: 8,
        flexDirection: "column",
        fontFamily: "OpenSans",
    },
    containerNamaBarang: {
        width: "100%",
        flexDirection: "column",
    },
    namaBarang: {
        textAlign: "left",
        fontSize: 8,
        marginBottom: 1,
        fontFamily: "OpenSansSemiBold",
    },
    qty: {
        width: "15%",
        textAlign: "left",
        fontSize: 8,
    },
    hargaSatuan: {
        width: "40%",
        fontSize: 8,
        textAlign: "left",
    },
    rate: {
        width: "45%",
        textAlign: "right",
        fontSize: 8,
    },
    keterangan: {
        width: "55%",
        textAlign: "left",
        fontSize: 8,
    },
    divider: {
        marginVertical: 4,
        borderTop: "1px",
        color: "black",
        borderStyle: "dashed",
    },
    containerInfoTransaksi: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        fontFamily: "OpenSans",
    },
    infoTransaksi: {
        fontSize: 8,
        width: "50%",
        textAlign: "left",
    },
    nilaiTransaksi: {
        width: "50%",
        fontSize: 8,
        textAlign: "right",
    },
    infoTransaksiBold: {
        fontSize: 8,
        fontFamily: "OpenSansSemiBold",
        width: "40%",
        textAlign: "left",
    },
    nilaiTransaksiBold: {
        width: "50%",
        fontSize: 8,
        fontFamily: "OpenSansSemiBold",
        textAlign: "right",
    },
    containerPenutup: {
        marginTop: 14,
        display: "flex",
        flexDirection: "column",
        // justifyContent: "center",
        // alignItems: "center",
        fontSize: 8,
        fontFamily: "OpenSansSemiBold",
    },
    containerBelumLunas: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 8,
        fontFamily: "OpenSans",
    },
    penutup: {
        fontSize: 8,
        fontFamily: "OpenSansSemiBold",
    },
    containerWaterMark: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 6,
        marginTop: 10,
        marginBottom: 5,
        fontFamily: "OpenSans",
    },
    containerNore: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 6,
    },
    containerLogo: {
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 12,
        marginBottom: 6,
    },
    logo: {
        width: 54,
        height: 54,
        display: "flex",
        flexDirection: "column",
        textAlign: "center",
        alignItems: "center",
        justifyContent: "center",
    },
    qr: {
        width: "3cm",
        height: "3cm",
        display: "flex",
        flexDirection: "column",
        textAlign: "center",
        alignItems: "center",
        justifyContent: "center",
    },
    boldText: {
        fontWeight: 700,
        fontFamily: "OpenSansSemiBold",
    },
    containerJatuhTempo: {
        width: "100%",
        marginTop: 10,
        marginBottom: 14,
    },
});

const stylesheet = {
    // clear margins for all <p> tags
    p: {
        display: "block",
        margin: 0,
    },
};

interface ICart {
    id: number;
    namaBarang: string;
    sku?: string | undefined;
    qty: number;
    harga: number;
    jumlahStok?: number | undefined;
}

interface IPrintStrukProps {
    namaToko: string;
    gambarToko?: string;
    alamatToko: string;
    telpToko: string;
    total: number;
    kasir: string;
    sales: string | null;
    tanggalTransaksi: string;
    cart: ICart[] | undefined;
    diskon?: number;
    pajak?: number;
    tunai?: number;
    kembalian?: number;
    isPro: number;
    namaMetode?: string | null;
    belumLunas?: boolean;
    qr?: string | null;
    html?: any;
    keterangan?: string | null;
    noInvoice: string;
    subTotal: number;
    keteranganCustomAmount?: string | null;
    hargaCustomAmount?: string | null;
    keteranganOngkir?: string | null;
    hargaOngkir?: string | null;
    jatuhTempo: string | null;
    metodePelanggan: string | null;
    dpp?: number;
    persenPajak?: number;
}

const PrintStrukPdf = (props: IPrintStrukProps) => {
    const rows =
        props.cart &&
        props.cart.map((row) => (
            <View style={styles.column} key={row.id}>
                <View style={{ width: "65%", flexDirection: "column" }}>
                    <Text style={styles.namaBarang}>{row.namaBarang}</Text>
                </View>
                <View style={{ flexDirection: "row" }}>
                    <Text style={styles.qty}>{row.qty}x</Text>
                    <Text style={styles.hargaSatuan}>
                        @{toRibuan(row.harga)}
                    </Text>
                    <Text style={styles.rate}>
                        {toRibuan(row.harga * row.qty)}
                    </Text>
                </View>
            </View>
        ));

    return (
        <Document>
            <Page
                wrap
                size={{ width: "5.5cm", height: "100%" }}
                // size={{width: }}
                style={styles.page}
            >
                <View>
                    {props.gambarToko ? (
                        <View style={styles.containerLogo}>
                            <Image style={styles.logo} src={props.gambarToko} />
                        </View>
                    ) : (
                        <View></View>
                    )}
                    <View style={styles.containerTitle}>
                        <View style={styles.title}>
                            <Text>{props.namaToko}</Text>
                        </View>
                        <View style={styles.subtitle}>
                            <Text>{props.alamatToko}</Text>
                        </View>
                        <View style={styles.subtitle}>
                            <Text>+{props.telpToko}</Text>
                        </View>
                    </View>
                    {props.qr ? (
                        <View style={styles.containerLogo}>
                            <Image style={styles.qr} src={props.qr} />
                        </View>
                    ) : (
                        <View></View>
                    )}
                    {props.jatuhTempo ? (
                        <View style={styles.containerJatuhTempo}>
                            <View
                                style={{
                                    textAlign: "center",
                                    fontFamily: "OpenSansMedium",
                                    fontSize: 8,
                                    marginBottom: 14,
                                }}
                            >
                                <Text>INVOICE</Text>
                            </View>
                            <View
                                style={{
                                    border: "1px solid #000",
                                    padding: 3,
                                    width: "100%",
                                }}
                            >
                                <Text
                                    style={{
                                        textAlign: "center",
                                        fontFamily: "OpenSansBold",
                                        fontSize: 7,
                                    }}
                                >
                                    Jatuh Tempo pada {props.jatuhTempo}
                                </Text>
                            </View>
                        </View>
                    ) : (
                        <View></View>
                    )}
                    <View style={styles.tanggalTransaksi}>
                        <Text>Kasir</Text>
                        <Text>{props.kasir}</Text>
                    </View>
                    {props.sales !== null ? (
                        <View style={styles.tanggalTransaksi}>
                            <Text>Sales</Text>
                            <Text>{props.sales}</Text>
                        </View>
                    ) : (
                        <View></View>
                    )}
                    <View style={styles.tanggalTransaksi}>
                        <Text>Tanggal</Text>
                        <Text>{props.tanggalTransaksi}</Text>
                    </View>
                    {props.namaMetode ? (
                        <View style={styles.tanggalTransaksi}>
                            <Text>Metode</Text>
                            <Text>{props.namaMetode}</Text>
                        </View>
                    ) : (
                        <View></View>
                    )}
                    {props.noInvoice ? (
                        <View style={styles.tanggalTransaksi}>
                            <Text>Nomor</Text>
                            <Text>{props.noInvoice}</Text>
                        </View>
                    ) : (
                        <View></View>
                    )}
                    {props.metodePelanggan ? (
                        <View style={styles.tanggalTransaksi}>
                            <Text>Pelanggan</Text>
                            <Text>{props.metodePelanggan}</Text>
                        </View>
                    ) : (
                        <View></View>
                    )}
                    {props.keterangan ? (
                        <View style={styles.tanggalTransaksi}>
                            <Text>Keterangan</Text>
                            <Text>{props.keterangan}</Text>
                        </View>
                    ) : (
                        <View></View>
                    )}
                    <View style={styles.divider}></View>
                    <View>{rows}</View>
                    {props.keteranganCustomAmount ? (
                        <View style={styles.column}>
                            <View
                                style={{
                                    width: "65%",
                                    flexDirection: "column",
                                }}
                            >
                                <Text style={styles.namaBarang}>
                                    Custom Amount
                                </Text>
                            </View>
                            <View style={{ flexDirection: "row" }}>
                                <Text style={styles.keterangan}>
                                    {props.keteranganCustomAmount}
                                </Text>
                                <Text style={styles.rate}>
                                    {toRibuan(
                                        Number(
                                            props.hargaCustomAmount?.replace(
                                                /\./g,
                                                "",
                                            ),
                                        ),
                                    )}
                                </Text>
                            </View>
                        </View>
                    ) : (
                        <View></View>
                    )}
                    {props.keteranganOngkir ? (
                        <View style={styles.column}>
                            <View
                                style={{
                                    width: "65%",
                                    flexDirection: "column",
                                }}
                            >
                                <Text style={styles.namaBarang}>
                                    Ongkos Kirim
                                </Text>
                            </View>
                            <View style={{ flexDirection: "row" }}>
                                <Text style={styles.keterangan}>
                                    {props.keteranganOngkir}
                                </Text>
                                <Text style={styles.rate}>
                                    {toRibuan(
                                        Number(
                                            props.hargaOngkir?.replace(
                                                /\./g,
                                                "",
                                            ),
                                        ),
                                    )}
                                </Text>
                            </View>
                        </View>
                    ) : (
                        <View></View>
                    )}
                    <View style={styles.divider}></View>
                    <View style={styles.containerInfoTransaksi}>
                        <Text style={styles.infoTransaksi}>Subtotal</Text>
                        <Text style={styles.nilaiTransaksi}>
                            {toRupiahDesimal(props.subTotal)}
                        </Text>
                    </View>
                    {props.hargaCustomAmount ? (
                        <View style={styles.containerInfoTransaksi}>
                            <Text style={styles.infoTransaksi}>
                                Custom Amount
                            </Text>
                            <Text style={styles.nilaiTransaksi}>
                                {toRupiahDesimal(
                                    Number(props.hargaCustomAmount),
                                )}
                            </Text>
                        </View>
                    ) : (
                        <View></View>
                    )}
                    {props.hargaOngkir ? (
                        <View style={styles.containerInfoTransaksi}>
                            <Text style={styles.infoTransaksi}>
                                Ongkos Kirim
                            </Text>
                            <Text style={styles.nilaiTransaksi}>
                                {toRupiahDesimal(Number(props.hargaOngkir))}
                            </Text>
                        </View>
                    ) : (
                        <View></View>
                    )}
                    {props.diskon ? (
                        <View style={styles.containerInfoTransaksi}>
                            <Text style={styles.infoTransaksi}>Diskon</Text>
                            <Text style={styles.nilaiTransaksi}>
                                {toRupiahDesimal(props.diskon)}
                            </Text>
                        </View>
                    ) : (
                        <View></View>
                    )}
                    <View style={styles.divider}></View>
                    <View style={styles.containerInfoTransaksi}>
                        <Text style={styles.infoTransaksiBold}>Total</Text>
                        <Text style={styles.nilaiTransaksiBold}>
                            {toRupiahDesimal(props.total)}
                        </Text>
                    </View>
                    <View style={styles.divider}></View>
                    {props.tunai ? (
                        <View style={styles.containerInfoTransaksi}>
                            <Text style={styles.infoTransaksi}>
                                {props.namaMetode}
                            </Text>
                            <Text style={styles.nilaiTransaksi}>
                                {toRupiahDesimal(props.tunai)}
                            </Text>
                        </View>
                    ) : (
                        <View></View>
                    )}
                    {props.kembalian ? (
                        <View style={styles.containerInfoTransaksi}>
                            <Text style={styles.infoTransaksi}>Kembalian</Text>
                            <Text style={styles.nilaiTransaksi}>
                                {toRupiahDesimal(props.kembalian)}
                            </Text>
                            <View style={styles.divider}></View>
                        </View>
                    ) : (
                        <View></View>
                    )}
                    {props.dpp ? (
                        <Text style={{ fontFamily: "OpenSans", fontSize: 8 }}>
                            DPP= {toRupiahDesimal(Number(props.dpp))}
                        </Text>
                    ) : (
                        <View></View>
                    )}
                    {props.pajak ? (
                        <Text style={{ fontFamily: "OpenSans", fontSize: 8 }}>
                            PPN ({props.persenPajak}%)={" "}
                            {toRupiahDesimal(Number(props.pajak))}
                        </Text>
                    ) : (
                        <View></View>
                    )}
                    {props.belumLunas ? (
                        <View>
                            <View style={styles.divider}></View>
                            <View style={styles.containerBelumLunas}>
                                <Text style={styles.penutup}>BELUM LUNAS</Text>
                            </View>
                            <View style={styles.divider}></View>
                        </View>
                    ) : (
                        <View></View>
                    )}
                    {props.jatuhTempo ? (
                        <View
                            style={{
                                flexDirection: "column",
                                justifyContent: "center",
                                fontSize: 8,
                                fontFamily: "OpenSans",
                                marginTop: 16,
                            }}
                        >
                            <Text style={{ textAlign: "center" }}>
                                Pembayaran dapat dibayar melalui:
                            </Text>
                            <Text style={{ textAlign: "center" }}>
                                BCA 8165818080
                            </Text>
                            <Text style={{ textAlign: "center" }}>
                                PT. Kiko Mart Indonesia
                            </Text>
                        </View>
                    ) : (
                        <View></View>
                    )}
                    <View style={styles.containerPenutup}>
                        {props.html ? (
                            <Html
                                stylesheet={stylesheet}
                                style={{ fontSize: 8 }}
                            >
                                {`<div>${props.html}</div>`}
                            </Html>
                        ) : (
                            // <div
                            //     dangerouslySetInnerHTML={{ __html: props.html }}
                            // />
                            <View
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    // justifyContent: "center",
                                    // alignItems: "center",
                                }}
                            >
                                <Text style={styles.penutup}>
                                    Barang yang sudah dibeli tidak dapat
                                    dikembalikan.
                                </Text>
                                <Text style={styles.penutup}>
                                    Kami nantikan kunjungan anda selanjutnya.
                                </Text>
                            </View>
                        )}
                    </View>
                    <View style={styles.containerWaterMark}>
                        <Text>
                            {props.isPro !== 1 && (
                                <Text style={styles.boldText}>Free</Text>
                            )}{" "}
                            POS System by UKM Lokal
                        </Text>
                    </View>
                </View>
            </Page>
        </Document>
    );
};

export default PrintStrukPdf;
